// extracted by mini-css-extract-plugin
module.exports = {"root":"_9sN6K","open":"km8ej","inner":"_3Yu3C","box":"_1xaMb","arrowalt":"-dtxI","squeeze":"_3VHen","elastic":"Xf4RS","collapse":"ICb9V","spring":"im0CX"};